import {
  HTTP_GETBUDGETSDETAILREPORT_FETCHING,
  HTTP_GETBUDGETSDETAILREPORT_SUCCESS,
  HTTP_GETBUDGETSDETAILREPORT_FAILED,
  HTTP_RESET_BUDGETSDETAILREPORT,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETBUDGETSDETAILREPORT_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETBUDGETSDETAILREPORT_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETBUDGETSDETAILREPORT_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    case HTTP_RESET_BUDGETSDETAILREPORT:
      return initialState;
    default:
      return state;
  }
};
